import { bindable, inject } from 'aurelia';
import { CustomIntervalEntity } from '../../apis/custom-interval/custom-interval-entity';
import { ScheduleViewModel } from './schedule-view-model';
import { ScheduleRowEntity } from '../../apis/schedule/schedule-row-entity';
import { SerieSettingEntity } from '../../apis/serie/serie-setting-entity';
import { EventAggregator } from '@aurelia/kernel';
import { TeamSettingEntity } from '../../apis/team/team-setting-entity';
import { I18N } from '@aurelia/i18n';
import { VenueEntity } from '../../apis/venue/venue-entity';

@inject(EventAggregator, I18N)
export class CustomRowsEditor {
    @bindable public games: ScheduleRowEntity[] = [];
    @bindable public serie: SerieSettingEntity = null;
    @bindable public scheduleid: string = null;
    @bindable public customIntervals: CustomIntervalEntity[] = [];
    @bindable public teamSettings: TeamSettingEntity[] = [];
    @bindable public venues: VenueEntity[] = [];
    public text: string = '';
    public afterInterval: number = -1;
    public bindingDone: boolean = false;
    public intervalOptions: IntervalOption[] = [];
    public viewModel: ScheduleViewModel = null;
    public editingIndex: number | null = null;
    private _duration: number = 30;
    private _i18n: I18N;
    constructor(eventAggregator: EventAggregator, i18n: I18N) {
        this.viewModel = new ScheduleViewModel(eventAggregator);
        this._i18n = i18n;
    }

    public attached(): void {
        this.bindingDone = true;
        this.setupSchedule();
    }
    public gamesChanged(): void {
        if (this.bindingDone) {
            this.setupSchedule();
        }
    }

    public serieChanged(): void {
        if (this.bindingDone) {
            this.setupSchedule();
        }
    }
    public customIntervalsChanged(): void {
        if (this.bindingDone) {
            this.setupSchedule();
        }
    }
    public teamSettingsChanged(): void {
        if (this.bindingDone) {
            this.setupSchedule();
        }
    }
    public venuesChanged(): void {
        if (this.bindingDone) {
            this.setupSchedule();
        }
    }

    public get duration(): string {
        return this._duration.toString();
    }
    public set duration(value: string) {
        this._duration = parseInt(value, 10);
    }
    public get schedules(): any[] {
        return []; // this.viewModel.scheduleShortRows;
    }
    public get fields(): number {
        return this.serie.fields;
    }

    public get intervalAlreadyAdded(): boolean {
        return this.customIntervals.any(i => i.afterInterval === this.afterInterval);
    }

    public setupSchedule(): void {

        if (!this.games || !this.serie || !this.customIntervals) {
            return;
        }

        this.viewModel.initialize(this.games, this.serie, this.customIntervals, this.teamSettings, this.venues, [], true);

        this.intervalOptions.clear();
        this.intervalOptions.add(new IntervalOption(-1, this._i18n.tr('ui:before_interval_one')));
        for (let i = 0; i < this.viewModel.intervalCount; i++) {
            this.intervalOptions.add(new IntervalOption(i, this._i18n.tr('ui:after_interval') + ' ' + (i + 1)));
        }
    }

    public addRow(): void {
        const c = new CustomIntervalEntity();
        c.afterInterval = this.afterInterval;
        c.text = this.text;
        c.duration = this._duration;
        this.customIntervals.add(c);
        this._resetForm();
        this.setupSchedule();
    }

    public editRow(index: number): void {
        const row = this.viewModel.gameRows[index];
        const customInterval = this.customIntervals.firstOrDefault(c => c.afterInterval === row.interval);
        if (!customInterval) { return; }
        this.text = customInterval.text;
        this.afterInterval = customInterval.afterInterval;
        this._duration = customInterval.duration;
        this.editingIndex = index;
    }

    public updateRow(): void {
        const row = this.viewModel.gameRows[this.editingIndex];
        const customInterval = this.customIntervals.firstOrDefault(c => c.afterInterval === row.interval);
        if (!customInterval) { return; }
        customInterval.text = this.text;
        customInterval.duration = this._duration;
        customInterval.afterInterval = this.afterInterval;
        this._resetForm();
        this.setupSchedule();
    }

    public onDeleteRow(index: number): void {
        const customIndex = this.viewModel.gameRows[index].interval;
        this.viewModel.gameRows.splice(index, 1);
        const customInterval = this.customIntervals.firstOrDefault(c => c.afterInterval === customIndex);
        this.customIntervals.remove(customInterval);
        this._resetForm();
    }

    private _resetForm(): void {
        this.text = '';
        this.afterInterval = -1;
        this._duration = 30;
        this.editingIndex = null;
    }
}

export class IntervalOption {
    public index: number = null;
    public name: string = null;

    constructor(index: number, name: string) {
        this.index = index;
        this.name = name;
    }
}
